export default __webpack_public_path__ + "assets/images/4.cdbea6.png";